import { BehaviorSubject } from 'rxjs';

import HowItWorksDialog from '../components/common/HowItWorksDialog';

export default class PaymentRedirectResultBloc {
  isValidSession$ = new BehaviorSubject(null);
  error$ = new BehaviorSubject(null);

  constructor({ paymentRepository, dialogRepository, userRepository }) {
    this.paymentRepository = paymentRepository;
    this.dialogRepository = dialogRepository;
    this.userRepository = userRepository;
  }

  get userDetails$() {
    return this.userRepository.userDetails$;
  }

  async isValidSession(sessionId) {
    try {
      const result = await this.paymentRepository.isValidSession(sessionId);
      this.isValidSession$.next(result);
    } catch (ignore) {
      this.error$.next('Invalid session id');
    }
  }

  openHowItWorksDialog() {
    this.dialogRepository.loadDialog(HowItWorksDialog, {}, true, true);
  }
}
